import fetch from 'isomorphic-fetch';

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */

const commonHeader = {
    "app-type":"W",
    "Authorization":`${process.env.AUTH_BASIC}`
};

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
//   if (response.status === 200) {
    // console.log("IN REQUESTS FILE: ", response.text);
    const contentType = response.headers.get("content-type") || "";
    if (contentType.includes("application/pdf")) {
        return response.arrayBuffer().then(buffer => {
            return new Promise(resolve => resolve(buffer));
        });
    } else {
        return response.json().then(data=>{
            return new Promise((resolve)=>{return resolve(data)})
        })
    }
//   }else if(response.status === 401) {
      // c("Auth Token Invalid");
//   }

//   const error = new Error(response.statusText);
//   error.response = response;
//   throw error;
}

function checkEncStatus(response) {
    if (response.status === 200) {
      // console.log("IN REQUESTS FILE: ", response.text);
      return response.text().then(data=>{
          // data && data.data && data.data.meta && store.dispatch({type:'ADD_META_DATA',data: data.data.meta});
          return new Promise((resolve)=>{return resolve(data)})
      })
    }else if(response.status === 401) {
        // c("Auth Token Invalid");
    }
  
    const error = new Error(response.statusText);
    error.response = response;
    throw error;
}
  

function toQueryString(obj) {
    return Object.keys(obj).map(k => {
        return encodeURIComponent(k) + "=" + encodeURIComponent(obj[k])
    })
        .join("&");
}


/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request({url, options}, query) {
    if(url=='https://hdfc-beta-kong.tothenew.net/authorization/v1/oauth/token'){
        options.headers = options.headers || {};
        options.headers = {...options.headers,...commonHeader};
        options.headers['content-type'] = 'application/x-www-form-urlencoded';
    }

    if(query) {
      url += '?' + toQueryString(query);
    }
    if(url.includes("verifyKYC") || url.includes("preLogin/verifyOTP") || url.includes("resendOTP") || url.includes("savePreLoginData") || url.includes("force/logout") || url.includes("ecart/kyc/verify") || url.includes("basket/validate/schemes")){
        return fetch(url,options).then(checkEncStatus)
    }
    else return fetch(url,options).then(checkStatus)
}
